<av-card class="calendar" [backdrop]="false">
  <div class="calendar-header">
    {{ appointment.start | amLocale : lang() | amDateFormat : "MMMM" }}
  </div>
  <av-card-body size="md" type="container">
    <div class="fx-column fx-gap-sm fx-align-center">
      <div>
        {{ appointment.start | amLocale : lang() | amDateFormat : "dddd" }}
      </div>
      <h1>
        {{ appointment.start | amLocale : lang() | amDateFormat : "DD" }}
      </h1>
      <div class="fx-column fx-gap-xs fx-align-center">
        <h4>
          {{ appointment.start | amLocale : lang() | amDateFormat : "HH:mm" }}
        </h4>
        <small class="text-muted">({{ timezoneOffset() }})</small>
      </div>
    </div>
  </av-card-body>
</av-card>
